import React, {PropTypes} from 'react';
import { Image } from 'react-bootstrap';

export default class TabBarItem extends React.Component {
  render() {

    const { imageClass, title } = this.props


    return (<div className="tab-bar-item">

        <div className={imageClass + " tab-bar-item-image"}></div>
        <span>{title}</span>

      </div>);
  }
}

TabBarItem.propTypes = {
};



// WEBPACK FOOTER //
// ./src/core/components/TabBarItem.js